import { PermissionsInfoModelModel as Model } from './Model'


export const MODULE_NAME = 'permissions.info-models'


export const PERMISSIONS_INFOMODELS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: PERMISSIONS_INFOMODELS_ROUTES.LAYOUT,
  route: { name: PERMISSIONS_INFOMODELS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-account-group-outline',
} as const
